(function() {
    var argusAnalysis = {
        init: function() {
            var self = this;

            if(!lgkorUI.isLogin) return;

            self.$cont = $('.contents');
            self.$argusPopup = $('#argusPopup');
            self.isEngineer = $('.support').hasClass('service-engineer'); //출장
            self.isMain = $('.contents').hasClass('support-home'); //메인
            
     
            self.$cont.on('callArgusAnalysis', function(e, data) {

                self.data = {};
                $.extend(true, self.data, data);

                self.requestArgus(self.data);

            });

            self.$argusPopup.find(".btn-confirm").on("click", function(e){
                var val = self.$argusPopup.find("[name=argusType]:checked").val();

                //메인
                if(self.isMain){
                    if(val == 'Y'){
                       self.data = $.extend(self.data, self.symptom);

                        var href = "/support/service-engineer-reservation?productCode="+self.data.productCode+"&mktModelCd="+self.data.modelCode; 
                            href += "&topic="+self.data.topic+"&subTopic="+self.data.subTopic+"&sympCodeThree="+self.data.sympCodeThree+"&topicNm="+self.data.topicNm+"&subTopicNm="+self.data.subTopicNm+"&sympNameThreeNm="+self.data.sympNameThreeNm;
                            href += "&accessType=001&argFlag=Y"; //argFlag=Y

                        setTimeout(function(){
                            location.href = href;
                        }, 100);
    
                    }else{
                        setTimeout(function(){
                            location.href = "/support/service-engineer-reservation?mktModelCd="+self.data.modelCode+"&accessType=001";
                        }, 100);
                    }
                }

                //출장
                if(self.isEngineer){

                    if(val == 'Y'){
                        $.extend(self.data, self.symptom, {argFlag: 'Y'}); //argFlag=Y
                        self.complete(self.data);
                        
                    }else{

                        self.complete(self.data);
                    }
                    
                }

                self.$argusPopup.vcModal('hide');

            });
        },

        complete: function complete(data) {
            var self = this;

            if (data) {
                for (var key in data) {
                    if (self.$cont.find('#'+key).length) {
                        self.$cont.find('#'+key).val(data[key]);
                    }
                }

            }
                
            self.$cont.trigger('complete', [data]);

        },
        requestArgus: function(d) {
            var self = this;

            var url = self.$argusPopup.data('ajax');
            var param = {
                productCode: d.productCode,
                serialNumber: d.serialNumber
            }
            
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(url, param, function(result) {
                var data = result.data;

                if(result.searchFlag == 'Y'){

                    self.symptom = {
                        topic: data.symptomCode,
                        subTopic: data.subSymptomCode,
                        sympCodeThree: data.subSubSymptomCode,
                        topicNm: data.sympNameOne,
                        subTopicNm: data.sympNameTwo,
                        sympNameThreeNm: data.sympNameThree,
                        productCode: data.productCode, //씽큐 productCode 넘김
                    }

                    self.$argusPopup.find('.sub-tit').html(data.description+"<br>전문 서비스매니저의 점검이 필요한 증상이에요.<br>이 증상으로 서비스를 접수할까요?");
                    if(data.hasOwnProperty('sympNameOne')){
                        self.$argusPopup.find('dd .txt-topic').html(data.sympNameOne + " &gt; " + data.sympNameTwo + " &gt; " + data.sympNameThree).show();
                    }else{
                        self.$argusPopup.find('dd .txt-topic').hide();
                    }
                    self.$argusPopup.find("input[id='argusType01']").prop('checked', true);
                    self.$argusPopup.vcModal();
                    

                } else if(result.searchFlag == 'N') {
                   
                    //메인
                    if(self.isMain){
                        location.href = "/support/service-engineer-reservation?mktModelCd="+d.modelCode+"&accessType=001";
                    }

                    //출장
                    if(self.isEngineer){
                        self.complete(d);
                    }
                }

            });

        }
    }

    $(window).ready(function() {
        argusAnalysis.init();
    });

})();